import { createFileRoute } from "@tanstack/react-router"
import DesignSystemBaselineSourceCard from "~/pages/design-system/components/BaselineSourceCard"

export const Route = createFileRoute(
  "/_auth/internal/design-system/components/baseline-source-card",
)({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemBaselineSourceCard />
}
